export default __webpack_public_path__ + "static/media/cv.f52ea42e.csv";